import { BreakpointProp } from "@/ui/lib";
import { DefinedDefaults, TWithDataComponent } from "@/ui/lib/types";
import { HTMLAttributes } from "react";

/*-------------------------------------
|  Constants
|-------------------------------------*/

export const ASPECT_RATIO_RATIO_CLASS_MAP = {
  content: "",
  "1:1": "aspect-square",
  "1:1.6": "aspect-[1/1.6]",
  "1:2": "aspect-[1/2]",
  "1.6:1": "aspect-[1.6/1]",
  "2:3": "aspect-[2/3]",
  "3:2": "aspect-[3/2]",
  "3:4": "aspect-[3/4]",
  "4:3": "aspect-[4/3]",
  "4:5": "aspect-[4/5]",
  "5:4": "aspect-[5/4]",
  "9:16": "aspect-[9/16]",
  "9:21": "aspect-[9/21]",
  "10:16": "aspect-[10/16]",
  "16:9": "aspect-video",
  "16:10": "aspect-[16/10]",
  "21:9": "aspect-[21/9]",
} as const;

export const ASPECT_RATIO_RESPONSIVE_RATIO_CLASS_MAP = {
  default: ASPECT_RATIO_RATIO_CLASS_MAP,
  xl: {
    content: "",
    "1:1": "xl:aspect-square",
    "1:1.6": "xl:aspect-[1/1.6]",
    "1:2": "xl:aspect-[1/2]",
    "1.6:1": "xl:aspect-[1.6/1]",
    "2:3": "xl:aspect-[2/3]",
    "3:2": "xl:aspect-[3/2]",
    "3:4": "xl:aspect-[3/4]",
    "4:3": "xl:aspect-[4/3]",
    "4:5": "xl:aspect-[4/5]",
    "5:4": "xl:aspect-[5/4]",
    "9:16": "xl:aspect-[9/16]",
    "9:21": "xl:aspect-[9/21]",
    "10:16": "xl:aspect-[10/16]",
    "16:9": "xl:aspect-video",
    "16:10": "xl:aspect-[16/10]",
    "21:9": "xl:aspect-[21/9]",
  },
} as const;

/*-------------------------------------
|  Types
|-------------------------------------*/

export type TAspectratioRatio = keyof typeof ASPECT_RATIO_RATIO_CLASS_MAP;

export type TAspectratioRatioProp =
  BreakpointProp<typeof ASPECT_RATIO_RESPONSIVE_RATIO_CLASS_MAP>;

export type TAspectRatioProps = {
  ratio?: TAspectratioRatioProp;
} & TWithDataComponent & HTMLAttributes<HTMLDivElement>;

type TAspectRatioDefaultProps = DefinedDefaults<
  TAspectRatioProps,
  "ratio" | "data-component"
>;

/*-------------------------------------
|  Defaults
|-------------------------------------*/

export const ASPECT_RATIO_DEFAULTS = {
  ratio: "1:1",
  "data-component": "AspectRatio",
} satisfies TAspectRatioDefaultProps;
